import PCIPrompt from './PCIPrompt'

export default PCIPrompt
